import React from 'react';
import classNames from 'classnames';

import RoundedSquareTick from '@images/roundedSquareTick.svg';

export default ({
  title,
  subtitle,
  features,
  children,
  border
}) => {
  return (
    <section id="pricing" className="py-5">
      <div className={classNames("container py-5", border ? 'border-top' : '')}>
        <div className="row">
          <div className="col-md-6">
            <div className="d-flex flex-column">
              <h2 className="font-semibold">{title}</h2>
              <p className="font-medium">
                {subtitle}
              </p>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-4">
            <div className="d-flex flex-column">
              <p className="font-semibold m-0">All plans include:</p>
              <ul className="list-unstyled m-0 p-0">
                {features.map((item, j) => (
                  <li key={j} className="card-text mt-2">
                    <RoundedSquareTick fill="#3795E2" width="20" height="20"/>
                    &nbsp;<span className="ml-2 text-capitalize font-medium">{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-md-8">
            {children}
          </div>
        </div>
      </div>
    </section>
  );
}
